import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ApplicationSettings, Group } from '@icure/api';
import { MatTableDataSource } from '@angular/material/table';
import { MatSortable } from '@angular/material/sort';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AppSettingsImportationDialogComponent } from '../dialogs/app-settings-importation-dialog/app-settings-importation-dialog.component';
import { listOfEncryptedSettings } from '../../../../../lib/services/application-settings.service';
import {
  AccessMatrixService,
  ModuleTypeEnum,
  RouteTypeEnum,
  SubModuleTypeEnum,
} from '../../../../../lib/services/access-matrix.service';

interface FormatedAppSettingsData {
  id: string;
  settings: string;
  encrypted: boolean;
}

interface AppSettingsOption {
  label: string;
  id: string;
}

interface AppSettingsDataRow {
  _id?: string;
  settings?: Record<string, unknown>;
}

@Component({
  selector: 'ms-database-group-info-app-settings',
  templateUrl: './database-group-info-app-settings.component.html',
  styleUrls: ['./database-group-info-app-settings.component.scss'],
  standalone: false,
})
export class DatabaseGroupInfoAppSettingsComponent {
  @ViewChild(MatSort, { static: true }) sort: MatSort | undefined;
  @ViewChild(MatPaginator, { static: true }) paginator:
    | MatPaginator
    | undefined;
  @Input() appSettings: Array<ApplicationSettings> = [];
  @Input() selectedGroup: Group = {};
  @Output() appSettingsCreated = new EventEmitter<void>();

  public displayedColumns: string[] = ['id', 'encrypted', 'settings'];
  public appSettingsOptions: AppSettingsOption[] = [
    { label: 'Config 1733', id: 'APPSETTINGS|1733-CONFIG|1.0.0' },
    { label: 'Module actif', id: 'APPSETTINGS|ACTIVE-FEATURES|1.0.0' },
    { label: 'Beoogo', id: 'APPSETTINGS|BEOOGO|PRD|1.0.1' },
    { label: 'Mode de connexion', id: 'APPSETTINGS|CONNECTION-MODE|1.0.0' },
    { label: 'eForm', id: 'APPSETTINGS|EFORM|PRD|1.0.0' },
  ];

  public dataSource!: MatTableDataSource<FormatedAppSettingsData>;
  public formattedAppSettingsDatas: Array<FormatedAppSettingsData> = [];
  public selectedFilter: string = '';
  public hasAppSettingsContent = false;
  public readonly isMedispringHost: boolean = /(^|\.)medispring\.be$/i.test(window.location.hostname);

  constructor(
    private dialog: MatDialog,
    public accessMatrixService: AccessMatrixService,
  ) {}

  ngOnInit() {
    this.sort?.sort({ id: '_id', start: 'asc' } as MatSortable);
    this.formattedAppSettingsDatas = this.createDataSource(this.appSettings);
    this.hasAppSettingsContent = this.formattedAppSettingsDatas.length > 0;
    this.dataSource = new MatTableDataSource(this.formattedAppSettingsDatas);
    this.dataSource.sort = this.sort;
  }

  private createDataSource(
    appSettings: Array<ApplicationSettings>,
  ): Array<FormatedAppSettingsData> {
    const dataSource: Array<FormatedAppSettingsData> = [];
    appSettings?.map((appSetting: ApplicationSettings & AppSettingsDataRow) => {
      const appSettingId: string = appSetting?._id ?? '';
      dataSource.push({
        id: appSettingId,
        settings: JSON.stringify(appSetting.settings),
        encrypted: listOfEncryptedSettings.some((type) =>
          appSettingId.includes(type),
        ),
      });
    });
    return dataSource;
  }

  public openAppSettingsImportationDialog(appSettingsId: string) {
    const currentAppSettings: ApplicationSettings | undefined =
      this.appSettings?.find(
        (appSetting: ApplicationSettings) =>
          (appSetting as ApplicationSettings & { _id?: string })?._id ===
          appSettingsId,
      );
    const dialogRef = this.dialog.open(AppSettingsImportationDialogComponent, {
      data: {
        appSettingsId: appSettingsId,
        selectedGroup: this.selectedGroup,
        currentAppSettings: currentAppSettings,
      },
      height: '700px',
      width: '1000px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.appSettingsCreated.emit();
      }
    });
  }

  public filterChanged() {
    const filteredAppSettings: Array<FormatedAppSettingsData> = [];

    this.dataSource.data = filteredAppSettings;

    if (this.selectedFilter) {
      const searchFilter = this.selectedFilter;
      this.dataSource.filter = searchFilter;
      if (searchFilter.length > 2) {
        this.dataSource.filter = searchFilter;
      } else {
        this.dataSource.filter = '';
      }
    } else {
      this.dataSource.filter = '';
    }
  }

  protected readonly RouteTypeEnum = RouteTypeEnum;
  protected readonly ModuleTypeEnum = ModuleTypeEnum;
  protected readonly SubModuleTypeEnum = SubModuleTypeEnum;
}
